// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logs-loading-container{margin:auto;margin-top:1rem;display:block;width:3rem}\n", ""]);
// Exports
module.exports = exports;
